import { slideUp } from "@/composables/slideUp";
import { slideDown } from "@/composables/slideDown";

export function slideToggle(elm: HTMLElement, duration = 300): Promise<void> {
  const display = window.getComputedStyle(elm).display;
  return display === "none" ? slideDown(elm, duration) : slideUp(elm, duration);
}
